import { RadioGroup } from './group';
import { Radio } from './radio';
const ExportRadio = Radio;
ExportRadio.Group = RadioGroup;
export { ExportRadio as Radio, RadioGroup };
